const params = new URLSearchParams(window.location.search)

export const platform = params.get('platform') as
  | 'ios'
  | 'googleplay_android'
  | 'china_android'

export const appVersion = params.get('app_version') ?? '0.0.0'

export const language = params.get('language') ?? 'en'
